import { requestApi } from './Api';

export const getClinicalNotes = async (navigate, params) =>
  requestApi({
    url: '/api/clinical_note/read_multiple',
    navigate,
    params
  });

export const getClinicalNote = async (navigate, params) =>
  requestApi({
    url: '/api/clinical_note/read',
    navigate,
    params
  });

export const getPatientHistory = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/clinical_note/patient/get_history',
    params
  });

export const getFilledAdvancedForms = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/clinical_note/filled_advanced_forms/get',
    params
  });

export const clearClinicalNote = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/clinical_note/clear',
    params
  });

export const nameClinicalNote = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/clinical_note/name',
    params
  });

export const clearClinicalNoteName = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/clinical_note/clear_name',
    params
  });

export const checkPatientNotes = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/clinical_note/patient_check',
    params
  });

export const upsertAggregateData = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/clinical_note/aggregate_data/upsert',
    params
  });
};

export const setAggregateDataVersions = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/clinical_note/aggregate_data/set_active_versions',
    params
  });
};

export const getAggregateNarrative = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/clinical_note/aggregate_narrative/get',
    params
  });
};

export const upsertAggregateNarrative = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/clinical_note/aggregate_narrative/upsert',
    params
  });
};

export const noKnownAggregateNarrative = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/clinical_note/aggregate_narrative/no_known/delete',
    params
  });
};
